const EMPTY = "";

export const normalizeNumberValue = (value) => {
  if (value === null || value === undefined || value === "") return EMPTY;
  if (typeof value === "number") return Number.isFinite(value) ? String(value) : EMPTY;

  const text = String(value).trim();
  if (text === "" || text === "-") return text;
  // Reject invalid edits rather than silently changing their numeric meaning.
  if (!/^-?[\d.]*,?\d*$/.test(text) || !/[\d,]/.test(text)) return null;
  const negative = text.startsWith("-");
  const [whole, fraction] = text.replace(/^-/, "").split(",");
  const integer = whole.replace(/\./g, "").replace(/^0+(?=\d)/, "") || "0";
  return `${negative ? "-" : ""}${integer}${fraction !== undefined ? `.${fraction}` : ""}`;
};

const expandExponent = (value) => {
  const match = value.match(/^(-?)(\d+)(?:\.(\d*))?e([+-]?\d+)$/i);
  if (!match) return value;
  const [, sign, whole, fraction = "", exponent] = match;
  if (Math.abs(Number(exponent)) > 1000) return EMPTY;
  const digits = whole + fraction;
  const position = whole.length + Number(exponent);
  if (position <= 0) return `${sign}0.${"0".repeat(-position)}${digits}`;
  if (position >= digits.length) return sign + digits + "0".repeat(position - digits.length);
  return `${sign}${digits.slice(0, position)}.${digits.slice(position)}`;
};

export const formatNumberInput = (value, { editing = false } = {}) => {
  if (value === null || value === undefined || value === "") return EMPTY;
  const text = expandExponent(String(value).trim());
  if (text === "-") return editing ? text : EMPTY;
  if (!text || !/^-?\d*(\.\d*)?$/.test(text)) return EMPTY;
  const negative = text.startsWith("-");
  const [integerSource, fractionSource] = text.replace(/^-/, "").split(".");
  const integer = (integerSource || "0").replace(/^0+(?=\d)/, "");
  const fraction = editing ? (fractionSource || "") : (fractionSource || "").replace(/0+$/, "");
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${negative ? "-" : ""}${grouped}${fraction || (editing && fractionSource !== undefined) ? `,${fraction}` : ""}`;
};

export const parsePastedNumber = (value) => {
  const text = String(value).trim().replace(/^Rp\.?\s*/i, "").replace(/\s/g, "");
  // A grouped Indonesian value wins over the ambiguous "1.234" decimal.
  if (/^-?[1-9]\d{0,2}(\.\d{3})+(,\d*)?$/.test(text)) return normalizeNumberValue(text);
  if (/^-?\d*(,\d*)?$/.test(text) && /\d/.test(text)) return normalizeNumberValue(text);
  if (/^-?\d+(\.\d*)?$/.test(text)) return text;
  if (/^-?\d{1,3}(,\d{3})+\.\d+$/.test(text)) return text.replace(/,/g, "");
  return null;
};

export const numericCaretPosition = (display, meaningfulCharacters) => {
  if (!meaningfulCharacters) return 0;
  let seen = 0;
  for (let index = 0; index < display.length; index += 1) {
    if (/\d|,|-/.test(display[index])) seen += 1;
    if (seen >= meaningfulCharacters) return index + 1;
  }
  return display.length;
};
